import { Routes } from '@angular/router';
import { roleMatchGuard } from './core/guards/role-match.guard';
import { rootRedirectGuard } from './core/guards/root-redirect.guard';
import { authGuard } from './core/guards/auth.guard';
import { loggedInGuard } from './core/guards/logged-in.guard';
import { registerRedirectGuard } from './auth/guards/register-redirect.guard';
import { OrganizationType } from './auth/interfaces';
import { legacyOfferClaimRedirectGuard } from './sponsor/offers/guards/legacy-offer-claim-redirect.guard';
import { superadminGuard } from './core/guards/superadmin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootRedirectGuard],
    children: [],
  },
  {
    path: 'login',
    canActivate: [loggedInGuard],
    loadComponent: () => import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    canActivate: [registerRedirectGuard],
    children: [],
  },
  {
    path: 'invite/entity',
    loadComponent: () =>
      import('./auth/invite-entity/invite-entity.component').then((m) => m.InviteEntityComponent),
  },
  {
    path: 'verify/:token',
    loadComponent: () => import('./auth/verify/verify.component').then((m) => m.VerifyComponent),
  },
  {
    path: 'magic-login/:token',
    loadComponent: () =>
      import('./auth/magic-login/magic-login.component').then((m) => m.MagicLoginComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'permission-denied',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/views/permission-denied/permission-denied.component').then(
        (m) => m.PermissionDeniedComponent
      ),
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.routes').then((m) => m.onboardingRoutes),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () => import('./views/settings/settings.routes').then((m) => m.settingsRoutes),
  },
  {
    path: 'admin',
    canMatch: [superadminGuard],
    loadChildren: () => import('./admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'entity',
    canMatch: [roleMatchGuard([OrganizationType.Entity])],
    loadChildren: () => import('./entity/entity.routes').then((m) => m.ENTITY_ROUTES),
  },
  {
    path: 'offers/:shortId',
    canActivate: [legacyOfferClaimRedirectGuard],
    children: [],
  },
  {
    path: 'sponsor',
    children: [
      {
        path: 'offers/claim/:shortId',
        loadComponent: () =>
          import('./sponsor/offers/sponsor-offer-claim/sponsor-offer-claim.component').then(
            (m) => m.SponsorOfferClaimComponent,
          ),
      },
      {
        path: '',
        canMatch: [roleMatchGuard([OrganizationType.Sponsor])],
        loadChildren: () => import('./sponsor/sponsor.routes').then((m) => m.SPONSOR_ROUTES),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
